import actions from './amenities-detail.actions';
import watch from './amenities-detail.operations';
import reducer, { initState } from './amenities-detail.reducers';

export { actions, watch, initState };

export default reducer;
